import { Component, OnInit } from '@angular/core';
import { LazyService } from '../../../services/lazy.service';
import { BaseService } from 'src/modules/base/shared/services/base.service';
import { DialogConfig } from '../../dialog/dialog-config';
import { AppService } from 'src/modules/base/shared/services/app.service';
import { RolePermissionService } from 'src/modules/base/shared/services/role-permission.service';
declare var QRCode: any;

@Component({
    selector: 'app-qr-code-generator',
    templateUrl: './qr-code-generator.component.html',
    styleUrls: ['./qr-code-generator.component.scss'],
    standalone: false
})
export class QrCodeGeneratorComponent implements OnInit {
  _loadedLibraries: any = {};
  _data: any;
  r_r_kx: any;

  constructor(
    private _lazy: LazyService,
    private dialogConfig: DialogConfig,
    private baseService: BaseService,
    private appService: AppService,
    private rolePermissionService: RolePermissionService
  ) { }

  ngOnInit(): void {
    this._data = this['dialogConfig']; let emptObj = {};
    this.baseService.buildDyanamicStr(Object.keys(this._data.action.params).map(x => x + ":" + this._data.action.params[x]).join(","), { data: this._data.data }).split(",").forEach((elem: any) => {
      emptObj[elem.split(":")[0]] = elem.split(":")[1]
    })
    this.r_r_kx = Object.assign({ "code_type": "r_r_kx" }, emptObj)
    this._lazy.loadScript("./assets/js/qr-code/generate-qr-code.min.js").then((res) => {
      this._loadedLibraries['url'] = "./assets/js/qr-code/generate-qr-code.min.js";
      this.generateCode();
    })
  }

  generateCode() {
    new QRCode(document.getElementById("generated-qr-code"), JSON.stringify(this.r_r_kx));
  }

  qrcodeprint() {
    var printUrl = "/printengine/api/v1/patient/print?queryId=GET_BY_ID&args=id:" + this._data.data.id + ",reportTemplateId:patientQRCode,contentType:pdf,account_id:" + this._data.data.account_id+",facility_id:"+this._data.data.facility_id+ "&application=patient-registration&filter=false"; 
    if(this.appService.checkNativeApp()){
      this.baseService.getFileByUrl(printUrl,false).subscribe((response) => {
        this.baseService.nativeFileHandling(response, "application/pdf", 'QrCode_' + this._data.data.uhId  +"_.pdf");
      });
    }else{
      window.open(printUrl)
    }
  }

  checkPermission(per_name?) {
    let permission=per_name?per_name:'patient_print';
    return this.rolePermissionService.checkAccessPermission(permission, "patient", "patient-registration");
  }

}
